/* =========================================================
   formulations.js
   Scroll-reveal for formulation cards, staggered per card.
   Respects prefers-reduced-motion. No dependencies.
   ========================================================= */

class PBFormulations {
  constructor(el) {
    this.el = el;
    this.cards = Array.from(el.querySelectorAll('.pb-formulations__card'));
    if (this.cards.length === 0) return;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.reducedMotion) {
      this.cards.forEach((c) => c.classList.add('is-visible'));
      return;
    }

    this.initObserver();
  }

  initObserver() {
    if (!('IntersectionObserver' in window)) {
      this.cards.forEach((c) => c.classList.add('is-visible'));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const card = entry.target;
          const idx = Number(card.dataset.cardIndex || 0);
          card.style.transitionDelay = `${idx * 90}ms`;
          card.classList.add('is-visible');
          this.observer.unobserve(card);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.1 }
    );

    this.cards.forEach((card) => this.observer.observe(card));
  }

  destroy() {
    if (this.observer) this.observer.disconnect();
  }
}

/* ---------- Init ---------- */
function initPBFormulations(root) {
  const scope = root || document;
  scope.querySelectorAll('.pb-formulations').forEach((el) => {
    if (!el.__pbFormulations) el.__pbFormulations = new PBFormulations(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPBFormulations());
} else {
  initPBFormulations();
}

document.addEventListener('shopify:section:load', (e) => initPBFormulations(e.target));
document.addEventListener('shopify:section:unload', (e) => {
  e.target.querySelectorAll('.pb-formulations').forEach((el) => {
    if (el.__pbFormulations) {
      el.__pbFormulations.destroy();
      delete el.__pbFormulations;
    }
  });
});
